import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const fieldCls = "bg-slate-900 border-slate-700 text-slate-100 h-10";

export const ResetPasswordDialog = ({ target, onClose }) => {
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const close = () => { setPwd(""); setConfirm(""); onClose(); };

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) return toast.error("Le password non coincidono");
    setSaving(true);
    try {
      await api.post(`/users/${target.id}/password`, { new_password: pwd });
      toast.success(`Password di ${target.name} aggiornata`);
      close();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && close()}>
      <DialogContent aria-describedby={undefined} className="bg-[#111827] border-slate-700 text-slate-100 sm:max-w-md" data-testid="reset-password-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Nuova password</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-400">Imposta una nuova password per <span className="text-slate-100">{target?.name}</span> ({target?.email}) e comunicagliela.</p>
        <form onSubmit={submit} className="space-y-3">
          <Input required type="password" minLength={8} placeholder="Nuova password (min 8)" value={pwd} onChange={(e) => setPwd(e.target.value)} className={fieldCls} data-testid="reset-password-new-input" />
          <Input required type="password" minLength={8} placeholder="Conferma password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={fieldCls} data-testid="reset-password-confirm-input" />
          <Button disabled={saving} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="reset-password-submit-button">
            {saving ? "Salvataggio…" : "Imposta password"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
